import React from 'react';
import { Container } from '../ui/Container';
import { XIcon } from 'lucide-react';
export const LeverageSection: React.FC = () => {
  const painPoints = ['Cold calling and cold emailing business owners', 'Chasing replies across fragmented outreach campaigns', 'Competing in broker-run processes after intent is already public'];
  return <section className="w-full bg-gradient-to-b from-dark-800 to-dark-900 py-24 md:py-32 relative overflow-hidden" data-id="element-631">
      <div className="absolute inset-0 bg-gradient-to-b from-dark-800/50 via-transparent to-dark-800/50" data-id="element-632" />
      <Container className="relative" data-id="element-633">
        {/* Main Content */}
        <div className="max-w-5xl mx-auto" data-id="element-634">
          {/* Header */}
          <div className="text-center mb-16 lg:mb-20" data-id="element-635">
            <p className="text-gray-400 text-lg md:text-xl mb-4" data-id="element-636">
              Your team's highest-leverage activity is not "sourcing deals"
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight max-w-4xl mx-auto" data-id="element-637">
              It's Speaking With Motivated Sellers, Making Offers & Structuring
              Deals
            </h2>
          </div>

          {/* Problem Context - Desktop: side by side layout */}
          <div className="bg-dark-800/60 border border-dark-600/50 rounded-xl p-8 md:p-10 lg:p-12 mb-12 lg:mb-16" data-id="element-638">
            <p className="text-gray-300 text-lg lg:text-xl mb-8 lg:mb-10 text-center max-w-2xl mx-auto" data-id="element-639">
              Most deal teams spend 80% of their time just trying to generate
              opportunities
            </p>

            {/* Mobile: stacked, Desktop: 3 columns */}
            <div className="space-y-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-6 max-w-4xl mx-auto" data-id="element-640">
              {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4 lg:flex-col lg:items-center lg:text-center lg:gap-3" data-id="element-641">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-red-500/10 border border-red-500/20" data-id="element-642">
                    <XIcon className="w-4 h-4 text-red-400" data-id="element-643" />
                  </div>
                  <p className="text-gray-400 pt-1 lg:pt-0 lg:text-sm" data-id="element-644">
                    {point}
                  </p>
                </div>)}
            </div>
          </div>

          {/* The Insight */}
          <div className="text-center max-w-4xl mx-auto" data-id="element-645">
            <h3 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 lg:mb-6" data-id="element-646">
              The Real Value Happens{' '}
              <span className="text-[#00c853]" data-id="element-647">After</span> A Qualified Seller
              Conversation Begins
            </h3>
            <p className="text-gray-400 text-lg md:text-xl lg:text-2xl" data-id="element-648">
              Deal Flow exists to automate everything up until that moment
            </p>
          </div>
        </div>
      </Container>
    </section>;
};